import BpkImage, {
  withLazyLoading,
  withLoadingBehavior,
} from '@skyscanner-internal/backpack-web/bpk-component-image';

import type { DesktopUrl } from '@skyscanner-internal/landing-pages-shared-types/types-shared/MobileLanding';

import STYLES from './AppStoreWidget.module.scss';

type AppStoreWidgetProps = {
  imageSrc: {
    appStore: string;
    playStore: string;
  };
  deeplinkUrl: string;
  desktopUrl: DesktopUrl;
};

const documentIfExists = typeof window !== 'undefined' ? document : null;
const FadingLazyLoadedImage = withLoadingBehavior(
  withLazyLoading(BpkImage, documentIfExists),
);

const AppStoreWidget = ({
  deeplinkUrl,
  desktopUrl,
  imageSrc,
}: AppStoreWidgetProps) => (
  <div className={STYLES.AppStoreButton__container}>
    {}
    <a
      href={`${deeplinkUrl}${
        deeplinkUrl.indexOf('?') >= 0 ? '&' : '?'
      }$desktop_url=${desktopUrl.apple}`}
      className={STYLES.AppStoreButton__imageLink}
    >
      <div className={STYLES.AppStoreButton__image}>
        <FadingLazyLoadedImage
          altText="App Store Button"
          src={imageSrc.appStore}
          aspectRatio={960 / 321}
        />
      </div>
    </a>
    {}
    <a
      href={`${deeplinkUrl}${
        deeplinkUrl.indexOf('?') >= 0 ? '&' : '?'
      }$desktop_url=${desktopUrl.google}`}
      className={STYLES.AppStoreButton__imageLink}
    >
      <div className={STYLES.AppStoreButton__image}>
        <FadingLazyLoadedImage
          altText="Play Store Button"
          src={imageSrc.playStore}
          aspectRatio={565 / 171}
        />
      </div>
    </a>
  </div>
);

export default AppStoreWidget;
